import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'

export const fieldsAdd = (values, handleChange) => {
  return [
    {
      label: 'Efectivo',
      name: 'efectivo',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.efectivo)),
      onChange: (e) => handleChange('efectivo', e.target.value),
    },
    {
      label: 'Debito',
      name: 'debito',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.debito)),
      onChange: (e) => handleChange('debito', e.target.value),
    },
    {
      label: 'Credito',
      name: 'credito',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.credito)),
      onChange: (e) => handleChange('credito', e.target.value),
    },
    {
      label: 'Mercado pago',
      name: 'mercadoPago',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.mercadoPago)),
      onChange: (e) => handleChange('mercadoPago', e.target.value),
    },
    {
      label: 'Cheque',
      name: 'cheque',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.cheque)),
      onChange: (e) => handleChange('cheque', e.target.value),
    },
    {
      label: 'Deposito',
      name: 'deposito',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.deposito)),
      onChange: (e) => handleChange('deposito', e.target.value),
    },
    {
      label: 'Transferencia',
      name: 'transferencia',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.transferencia)),
      onChange: (e) => handleChange('transferencia', e.target.value),
    },
    {
      label: 'Moneda extranjera',
      name: 'extranjera',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.extranjera)),
      onChange: (e) => handleChange('extranjera', e.target.value),
    },
  ]
}

export const fieldsAddDOS = (values, handleChange) => {
  return [
    {
      label: 'Efectivo',
      name: 'efectivo',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.efectivo)),
      onChange: (e) => handleChange('efectivo', e.target.value),
    },
    {
      label: 'Cheque',
      name: 'cheque',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.cheque)),
      onChange: (e) => handleChange('cheque', e.target.value),
    },
    {
      label: 'Moneda extranjera',
      name: 'extranjera',
      sm: 6,
      xs: 12,
      class: 'textfield',
      type: 'number',
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
      value: Math.max(0, parseFloat(values.extranjera)),
      onChange: (e) => handleChange('extranjera', e.target.value),
    },
  ]
}
